import { useMutation } from "@tanstack/react-query";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import {
  downloadEmploymentsExportWithRetry,
  ReportTimeoutError,
} from "src/Pages/Company/EmployeeManagement/Reports/downloadEmploymentsExportWithRetry";
import { getFileNameFromContentDisposition } from "src/utils/contentDisposition";

export enum ReportContentType {
  CSV = "text/csv",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
}

const REPORT_FILTER_MAP: Record<string, string> = {
  employed: "HEADCOUNT",
  incoming: "JOINERS",
  leaving: "LEAVERS",
};

interface ReportDownloadParams {
  companyId: string;
  structureId: string;
  contentType: ReportContentType;
  from: string;
  to: string;
  reportId: string;
}

const useDownloadReport = () =>
  useMutation({
    mutationFn: async (params: ReportDownloadParams) => {
      const filter = REPORT_FILTER_MAP[params.reportId];
      const response = await downloadEmploymentsExportWithRetry({
        companyId: params.companyId,
        structureId: params.structureId,
        contentType: params.contentType,
        from: params.from,
        to: params.to,
        filter,
      });

      const contentDisposition = response.headers["content-disposition"] ?? "";
      const fileName = getFileNameFromContentDisposition(
        contentDisposition,
        "export"
      );

      const file = await response.data.arrayBuffer();
      const url = URL.createObjectURL(new Blob([file]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    onError: (error: unknown) => {
      const message =
        error instanceof ReportTimeoutError
          ? __("Raport nie został przygotowany na czas. Spróbuj ponownie.")
          : __("Nie udało się pobrać pliku. Spróbuj ponownie.");
      dynamicNotification(message, "error");
    },
  });

export default useDownloadReport;
